
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherIssueGrid extends Serenity.EntityGrid<GiftVoucherIssueRow, any> {
        protected getColumnsKey() { return 'Retail.GiftVoucherIssue'; }
        protected getDialogType() { return GiftVoucherIssueDialog; }
        protected getIdProperty() { return GiftVoucherIssueRow.idProperty; }
        protected getInsertPermission() { return GiftVoucherIssueRow.insertPermission; }
        protected getLocalTextPrefix() { return GiftVoucherIssueRow.localTextPrefix; }
        protected getService() { return GiftVoucherIssueService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
        }

        protected addButtonClick() {

            let now = new Date();
            var dt = now.getDay();
            var mt = now.getMonth();
            var yr = now.getUTCFullYear();
            var hr = now.getUTCHours();
            var mn = now.getUTCMinutes();
            var sc = now.getUTCSeconds();


            this.editItem(<GiftVoucherIssueRow>{
                VoucherNo: 'GVI/' + dt + mt + yr + hr + mn + sc,                
                VoucherTypeId: 51,
                TransDate: now.toDateString()

            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}